import {all} from 'redux-saga/effects';
import authenticationSagas from './sagas/authentication';
import compositionSagas from './sagas/compositions';
import globalConfigurationSagas from './sagas/globalConfiguration';
import learningPathSagas from './sagas/learningPath';
import pedagogicalContentSagas from './sagas/pedagogicalContents';
import profileSagas from './sagas/profile';
import questionnaireSagas from './sagas/questionnaires';
import termsSagas from './sagas/terms';
import userFeelingsSagas from './sagas/userFeelings';

export default function* rootSaga() {
  yield all([
    ...authenticationSagas,
    ...compositionSagas,
    ...globalConfigurationSagas,
    ...learningPathSagas,
    ...pedagogicalContentSagas,
    ...questionnaireSagas,
    ...userFeelingsSagas,
    ...profileSagas,
    ...termsSagas,
  ]);
}
